export function htmlToStructuredText(html: string): string {
  const root = document.createElement('div');
  root.innerHTML = html;

  const inline = (node: Node): string => (node.textContent || '').replace(/\s+/g, ' ').trim();

  const serializeList = (listEl: Element, ordered: boolean, depth = 0): string => {
    const indent = '  '.repeat(depth);
    const lines: string[] = [];
    let index = 1;

    Array.from(listEl.children).forEach((li) => {
      if (li.tagName.toLowerCase() !== 'li') return;

      // Collect only the direct text/inline content of this li, skipping nested lists
      // so their items don't get merged into the parent item's text.
      const directText = Array.from(li.childNodes)
        .filter((n) => {
          if (n.nodeType === Node.ELEMENT_NODE) {
            const tag = (n as Element).tagName.toLowerCase();
            return tag !== 'ul' && tag !== 'ol';
          }
          return n.nodeType === Node.TEXT_NODE;
        })
        .map((n) => (n.textContent ?? '').replace(/\s+/g, ' ').trim())
        .filter(Boolean)
        .join(' ')
        .trim();

      if (directText) {
        lines.push(`${indent}${ordered ? `${index}.` : '•'} ${directText}`);
        index += 1;
      }

      // Recurse into any nested lists inside this li
      Array.from(li.children).forEach((child) => {
        const childTag = child.tagName.toLowerCase();
        if (childTag === 'ul' || childTag === 'ol') {
          const nested = serializeList(child, childTag === 'ol', depth + 1);
          if (nested) lines.push(nested);
        }
      });
    });

    return lines.join('\n');
  };

  const blocks: string[] = [];
  Array.from(root.childNodes).forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = (node.textContent || '').trim();
      if (text) blocks.push(text);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const el = node as Element;
    const tag = el.tagName.toLowerCase();
    if (tag === 'ul' || tag === 'ol') {
      const list = serializeList(el, tag === 'ol');
      if (list) blocks.push(list);
    } else {
      const text = inline(el);
      if (text) blocks.push(text);
    }
  });

  return blocks.join('\n\n');
}
